import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { MessageCircleIcon, BoxIcon } from 'lucide-react';
interface ServiceCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
  whatsappLink?: string;
  internalLink?: string;
  buttonText: string;
  index: number;
}
export function ServiceCard({
  icon: Icon,
  title,
  description,
  whatsappLink,
  internalLink,
  buttonText,
  index
}: ServiceCardProps) {
  const scrollToSection = (href: string) => {
    const id = href.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.2
  }} className="group relative bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-xl p-8 transition-all duration-500 flex flex-col overflow-hidden h-full" data-id="element-164">
      {/* Glow effect on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/0 via-yellow-400/0 to-yellow-400/0 group-hover:from-yellow-400/5 group-hover:via-yellow-400/10 group-hover:to-yellow-400/5 transition-all duration-500 rounded-xl" data-id="element-165" />

      {/* Corner accent */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-400/5 blur-3xl group-hover:bg-yellow-400/10 transition-all duration-500" data-id="element-166" />

      <div className="relative z-10 flex flex-col h-full" data-id="element-167">
        <motion.div whileHover={{
        scale: 1.1,
        rotate: 5
      }} transition={{
        type: 'spring',
        stiffness: 300
      }} className="bg-gradient-to-br from-yellow-400 to-yellow-500 w-16 h-16 rounded-lg flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(252,211,77,0.3)]" data-id="element-168">
          <Icon size={32} className="text-black" data-id="element-169" />
        </motion.div>

        <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300" data-id="element-170">
          {title}
        </h3>

        <p className="text-gray-300 leading-relaxed mb-6 flex-grow" data-id="element-171">
          {description}
        </p>

        <div className="mt-auto" data-id="element-172">
          {internalLink ? <Button variant="primary" onClick={() => scrollToSection(internalLink)} className="w-full" data-id="element-173">
              {buttonText}
            </Button> : <Button variant="primary" href={whatsappLink} className="w-full" data-id="element-174">
              <MessageCircleIcon size={20} data-id="element-175" />
              {buttonText}
            </Button>}
        </div>
      </div>
    </motion.div>;
}